import React, { useEffect, useState } from "react";
import { loader } from "../../loader";
import { ENDPOINT } from "../../axios/apiConfig";
import { postData } from "../../axios/apiHelper";
import moment from "moment";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Button, Tab, Tabs, ProgressBar } from "react-bootstrap";
import { copyToClipboard } from "../../Utils/CopyContent";
import CommonConfirmModel from "../../Model/CommonConfirmModel";
import CommonModel from "../../Model/CommonModel";
import {QRCodeCanvas} from "qrcode.react";


const ArticleDetailedView = ({ articleData, deletestatus, deleteContent }) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
    const rdLikeArray = ["56Ek4feL/1A8mZgIKQWEqg==", "bWmUjqX7J011   WUTYn9g==", "MXl8m36VZFYXpgFVz3Pg0g=="]
    const isLikeRdAccount = rdLikeArray.includes(localStorage.getItem("user_id"))
    const isRDAccount = isLikeRdAccount
    const isUSAPharmaAccount = localStorage?.getItem("account_type") === 'USA_PHARMA' ? 1 : 0;
    const BrokenImage =
        "https://docintel.s3-eu-west-1.amazonaws.com/cover/default/default.png";

    const [opening_details, setOpeningDetails] = useState([]);
    const [flag, setFlag] = useState(0);
    const [qrSize, setQrSize] = useState(290);
    const [show, setShow] = useState(false);
    const [heading, setHeading] = useState("");
    const [footerButton, setFooterButton] = useState("");
    const [modelData, setModelData] = useState();
    const [qrTitle, setQrTitle] = useState("");
    const [resetDataId, setResetDataId] = useState("");
    const [confirmationpopup, setConfirmationPopup] = useState(false);
    const [commonConfirmModelFun, setCommonConfirmModelFun] = useState(() => { });
    const [popupMessage, setPopupMessage] = useState({
        message1: "",
        message2: "",
        footerButton: "",
    });
    const [qrState, setQr] = useState({
        value: "",
    });

    const octaId = [
    "UbCJcnLM9fe HsRMgX8c1A==",
    "wW0geGtDPvig5gF 6KbJrg==",
    "z2TunmZQf3QwCsICFTLGGQ==",
    "qDgwPdToP05Kgzc g2VjIQ==",
    "B7SHpAc XDXSH NXkN0rdQ=="
  ];

    const downloadQRData = [
    {
      label: "Select Size",
      type: "dropdown",
      dropdown: [
        {
          key: "Tiny",
          value: "M",
        },
        {
          key: "Article",
          value: "H",
        },
        {
          key: "Large Print",
          value: "L",
        },
      ],
    },
  ];

    const imageOnError = (event) => {
        event.currentTarget.src = BrokenImage;
        event.currentTarget.className = "error";
    };

    const changeFormatForPrint = (value) => {
        let data = "";
        if (value?.allow_print) {
            data += "Print | ";
        }
        if (value?.allow_download) {
            data += "Download | ";
        }
        if (value?.allow_share) {
            data += "Share | ";
        }
        if (value?.chat_box) {
            data += "Request | ";
        }
        if (data) {
            data = data.trim().slice(0, -1);
        } else {
            data = "N/A";
        }
        return data;
    };

    const tabClicked = async (event, id) => {
        setFlag(0);

        if (event == "data-tab") {
            let index = opening_details.findIndex((el) => el.pdfId == id);
            if (index === -1) {
                let normal_data = opening_details;
                try {
                    let body = {
                        pdfId: [id],
                    };
                    const res = await postData(ENDPOINT.LIBRARYSTATS, body);
                    if (res?.data?.data?.[0]) {
                        let new_data = res?.data?.data?.[0];
                        normal_data.push(new_data);
                        setOpeningDetails(normal_data);
                        setFlag(flag + 1);
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        }
    };

    function LinkWithTooltip({ id, children, href, tooltip }) {
        return (
            <OverlayTrigger
                overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
                placement="top"
                delayShow={300}
                delayHide={150}
            >
                <a href={href}>{children}</a>
            </OverlayTrigger>
        );
    }

    const showConfirmationPopup = (stateMsg, id) => {
        if (stateMsg == "delete") {
            setResetDataId(id);
            setCommonConfirmModelFun(() => (id) => { deleteContent(id); setConfirmationPopup(false) });
            setPopupMessage({
                message1:
                    "You are about to remove this content.",
                message2: "Are you sure you want to do this?",
                footerButton: "Yes please!",
            });
            if (confirmationpopup) {
                setConfirmationPopup(false);
            } else {
                setConfirmationPopup(true);
            }
        }
    };

    const hideConfirmationModal = () => {
        setConfirmationPopup(false);
    };


    const handleSpcFun = (data) => {
        let newWindow = "";
        newWindow = window.open("/article_preview");
        newWindow.data = data;
    };

    const commonModelFun = (e, id, stateMsg, title = null) => {
        if (stateMsg == "downloadQR") {
            setHeading("Download QR");
            setFooterButton("Download");
            setModelData(downloadQRData);
            setResetDataId("");
            setQrTitle(title);
        }
        setShow(true);
    };

    const downloadQRCode = () => {
        const canvas = document.getElementById("qr-gen");
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `${qrTitle}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        setShow(false);
    };

    const handleQR = (e) => {
        if (e == "H") {
            setQrSize(390);
        }
        if (e == "L") {
            setQrSize(490);
        }
        setQr({ ...qrState, level: e });
    };
    
    return (
        <>
            <div className={`library-content-box-layuot d-flex w-100 ${isRDAccount ? "rd" : ""}`}>
                {
                    articleData?.length > 0 ?
                        articleData.map((data, index) => {
                            return (
                                <div className="doc-content-main-box" key={index} >
                                    <div className="doc-content-header">
                                        <div className="doc-content-header-logo">
                                            <a href="#">
                                                <img
                                                    alt="doc-logo"
                                                    src={data?.coverImage}
                                                    onError={imageOnError}
                                                    style={{ width: "67px" }}
                                                />
                                            </a>
                                        </div>
                                        <div className="doc-content">
                                            <h5
                                                dangerouslySetInnerHTML={{
                                                    __html: data?.title,
                                                }}
                                            ></h5>
                                            <h6>
                                                {data?.pdf_sub_title
                                                    ? data.pdf_sub_title
                                                    : data?.folder_name}
                                            </h6>
                                            <p className="author">{data?.key_author}</p>
                                            <div className="select-tags">
                                                {data?.tags?.length
                                                    ? JSON.parse(data.tags)?.map((data, index) => {
                                                        return <div key={index}>{data}</div>;
                                                    })
                                                    : ""}
                                            </div>
                                        </div>
                                        {
                                            deletestatus ? (
                                                <div className="dlt_btn">
                                                    <button
                                                        onClick={(e) =>
                                                            showConfirmationPopup("delete", data?.uniqueId)
                                                        }
                                                    >
                                                        <img
                                                            src={path_image + "delete.svg"}
                                                            alt="Delete Row"
                                                        />
                                                    </button>
                                                </div>
                                            ) : null
                                        }
                                    </div>
                                    <div className={`tabs-data ${isRDAccount ? "rd" : ""}`}>
                                        <Tabs
                                            onSelect={(key) => tabClicked(key, data?.id)}
                                            defaultActiveKey="docintel-link"
                                            fill
                                        >
                                            <Tab
                                                eventKey="docintel-link"
                                                title="Link"
                                                className="flex-column justify-content-between"
                                            >
                                                <div className="tab-panel d-flex flex-column justify-content-between">
                                                    <div className="tab-content-links">
                                                        <a href={data?.selectedSublinkUrl ? data?.selectedSublinkUrl : data?.docintelLink}
                                                            className="doc-link"
                                                            target="_blank"
                                                        >
                                                            {data?.selectedSublinkUrl ? data?.selectedSublinkUrl : data?.docintelLink}
                                                        </a>
                                                        <span
                                                            className="copy-content"
                                                            onClick={() => {
                                                                copyToClipboard(data?.selectedSublinkUrl ? data?.selectedSublinkUrl : data?.docintelLink);
                                                            }}
                                                        >
                                                            <img
                                                                src={path_image + "copy-content.svg"}
                                                                alt="Copy"
                                                            />
                                                        </span>
                                                    </div>
                                                    <ul className="tab-mail-list">
                                                        <li>
                                                            <h6 className="tab-content-title">
                                                                Upload date
                                                            </h6>
                                                            <h6>
                                                                {moment(data?.created).format(
                                                                    "DD MMM, YYYY"
                                                                )}
                                                            </h6>
                                                        </li>
                                                        <li>
                                                            <h6 className="tab-content-title">
                                                                inforMedGO code
                                                            </h6>
                                                            <h6>
                                                                {data?.rep_code}
                                                                <span
                                                                    className="copy-content"
                                                                    onClick={() => {
                                                                        copyToClipboard(data?.rep_code);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            path_image + "copy-content.svg"
                                                                        }
                                                                        alt="Copy"
                                                                    />
                                                                </span>
                                                            </h6>
                                                        </li>
                                                        <li>
                                                            <h6 className="tab-content-title">
                                                                Docintel code
                                                            </h6>
                                                            <h6>
                                                                {data.docintel_code}
                                                                {
                                                                    <span
                                                                        className="copy-content"
                                                                        onClick={() => {
                                                                            copyToClipboard(
                                                                                data?.docintel_code
                                                                            );
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                path_image + "copy-content.svg"
                                                                            }
                                                                            alt="Copy"
                                                                        />
                                                                    </span>
                                                                }
                                                            </h6>
                                                        </li>

                                                        <li>
                                                            <h6 className="tab-content-title">
                                                                Language
                                                            </h6>
                                                            <h6>
                                                                {data?.popup_email_content_language
                                                                    ? data?.popup_email_content_language
                                                                    : "No"}
                                                            </h6>
                                                        </li>
                                                        {!isLikeRdAccount ? (
                                                            <>
                                                                <li>
                                                                    <h6 className="tab-content-title">
                                                                        Link type
                                                                    </h6>
                                                                    <h6>{data?.linkType}</h6>
                                                                </li>
                                                                <li>
                                                                    <h6 className="tab-content-title">
                                                                        Enhanced
                                                                    </h6>
                                                                    <div className="include-links">
                                                                        {data?.spc_included ? (
                                                                            <img
                                                                                src={path_image + "spc-img.png"}
                                                                                alt=""
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}

                                                                        {data?.linkRelations ? (
                                                                            <img
                                                                                src={
                                                                                    path_image + "video-img.png"
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        {data?.pdfLinks ? (
                                                                            <img
                                                                                src={
                                                                                    path_image + "link-img.png"
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}

                                                                        {data.spc_included == 0 &&
                                                                            data.linkRelations == 0 &&
                                                                            data.pdfLinks == 0 && <h6>No</h6>}
                                                                    </div>
                                                                </li>
                                                            </>
                                                        ) : null}
                                                        {localStorage.getItem("user_id") == "m5JI5zEDY3xHFTZBnSGQZg==" ? (
                                                            <>
                                                                <li>
                                                                    <h6 className="tab-content-title">
                                                                        Status
                                                                    </h6>
                                                                    <h6>{data?.sold_unsold
                                                                        ? data?.sold_unsold
                                                                        : "N/A"}</h6>
                                                                </li>
                                                            </>
                                                        ) : null}
                                                    </ul>
                                                </div>
                                                {
                                                    !deletestatus && (
                                                        <div className="data-main-footer-sec">
                                                            <div
                                                                className={`footer-btn-wrapper ${[
                                                                    "wW0geGtDPvig5gF 6KbJrg==",
                                                                    "B7SHpAc XDXSH NXkN0rdQ==",
                                                                    "z2TunmZQf3QwCsICFTLGGQ==",
                                                                    "qDgwPdToP05Kgzc g2VjIQ==",
                                                                    "UbCJcnLM9fe HsRMgX8c1A==",
                                                                ].includes(
                                                                    localStorage.getItem("user_id")
                                                                ) ? "clone" : ""}`}
                                                            >
                                                                {!isLikeRdAccount ?
                                                                    <Button
                                                                        onClick={(e) => {
                                                                            commonModelFun(
                                                                                e,
                                                                                data?.selectedSublinkUrl ? data?.selectedSublinkUrl : data?.docintelLink,
                                                                                "downloadQR",
                                                                                data?.title
                                                                            );
                                                                            setQr({
                                                                                ...qrState,
                                                                                value: `${data?.selectedSublinkUrl ? data?.selectedSublinkUrl : data?.docintelLink}` + `~QRcode`,
                                                                            });
                                                                        }}
                                                                        className="footer-btn"
                                                                    >
                                                                        Download QR
                                                                    </Button> : ''}
                                                                {
                                                                    data?.spc_included ? (
                                                                        <button
                                                                            className="footer-btn btn-filled"
                                                                            onClick={() => handleSpcFun(data?.spcFile)}
                                                                        >
                                                                            Preview article
                                                                        </button>
                                                                    ) : (
                                                                        <a
                                                                            className="footer-btn btn-filled"
                                                                            href={data?.previewArticle}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            Preview article
                                                                        </a>
                                                                    )
                                                                }
                                                                
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </Tab>
                                            <Tab
                                                eventKey="data-tab"
                                                title="Data"
                                                className="flex-column justify-content-between"
                                            >
                                                <div className="data-main-box tab-panel d-flex flex-column justify-content-between">
                                                    <ul className="tab-mail-list data">
                                                        <li>
                                                            <h6 className="tab-content-title">
                                                                Openings (total)
                                                                <LinkWithTooltip tooltip="Number of opening counts for specific article.">
                                                                    <img
                                                                        src={
                                                                            path_image +
                                                                            "info_circle_icon.svg"
                                                                        }
                                                                        alt="refresh-btn"
                                                                    />
                                                                </LinkWithTooltip>
                                                            </h6>
                                                            <div className="data-progress limited">
                                                                <ProgressBar
                                                                    variant={
                                                                        opening_details.findIndex(
                                                                            (el) => el.pdfId == data?.id
                                                                        ) !== -1
                                                                            ? opening_details[
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                )
                                                                            ].opening > 0
                                                                                ? "success"
                                                                                : "default"
                                                                            : "default"
                                                                    }
                                                                    now={
                                                                        opening_details.findIndex(
                                                                            (el) => el.pdfId == data?.id
                                                                        ) !== -1
                                                                            ? opening_details[
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                )
                                                                            ].opening
                                                                            : "100"
                                                                    }
                                                                    label={
                                                                        opening_details.findIndex(
                                                                            (el) => el.pdfId == data?.id
                                                                        ) !== -1
                                                                            ? opening_details[
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                )
                                                                            ].opening
                                                                            : "Loading"
                                                                    }
                                                                />
                                                            </div>
                                                        </li>
                                                        {
                                                            data?.lastRomanNumber == 2 || data?.lastRomanNumber == 3 || data?.linkType == 'Sunshine' || data?.linkType == 'Sunshine USA' ?
                                                                (
                                                                    <>
                                                                        <li className="d-flex align-center">
                                                                            <h6 className="tab-content-title">
                                                                                Unique reader (total)
                                                                                <LinkWithTooltip tooltip="Number of unique HCPs who have opened the content (based on IP address, device &amp; browser).">
                                                                                    <img
                                                                                        src={
                                                                                            path_image +
                                                                                            "info_circle_icon.svg"
                                                                                        }
                                                                                        alt="refresh-btn"
                                                                                    />
                                                                                </LinkWithTooltip>
                                                                            </h6>
                                                                            <div className="data-progress send">
                                                                                <ProgressBar
                                                                                    variant={
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        ) !== -1
                                                                                            ? opening_details[
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                )
                                                                                            ]?.unique > 0
                                                                                                ? "warning"
                                                                                                : "default"
                                                                                            : "default"
                                                                                    }
                                                                                    now={
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        ) !== -1
                                                                                            ? (opening_details[
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                )
                                                                                            ]?.unique)
                                                                                            : "100"
                                                                                    }
                                                                                    label={
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        ) !== -1
                                                                                            ? opening_details[
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                )
                                                                                            ]?.unique
                                                                                            : "Loading"
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </li>

                                                                        {
                                                                            data?.lastRomanNumber == 2 ||
                                                                                data?.lastRomanNumber == 3 ?
                                                                                <li>
                                                                                    <h6 className="tab-content-title">
                                                                                        Article Usage
                                                                                        <LinkWithTooltip tooltip="Number of usage on the content.">
                                                                                            <img
                                                                                                src={
                                                                                                    path_image +
                                                                                                    "info_circle_icon.svg"
                                                                                                }
                                                                                                alt="refresh-btn"
                                                                                            />
                                                                                        </LinkWithTooltip>
                                                                                    </h6>
                                                                                    <div className="data-progress">
                                                                                        <ProgressBar
                                                                                            variant={
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                ) !== -1
                                                                                                    ? opening_details[
                                                                                                        opening_details.findIndex(
                                                                                                            (el) =>
                                                                                                                el.pdfId == data?.id
                                                                                                        )
                                                                                                    ]?.pinReaders
                                                                                                        ? "pin_usage"
                                                                                                        : "default"
                                                                                                    : "default"
                                                                                            }
                                                                                            now={
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                ) !== -1
                                                                                                    ? (opening_details[
                                                                                                        opening_details.findIndex(
                                                                                                            (el) =>
                                                                                                                el.pdfId == data?.id
                                                                                                        )
                                                                                                    ]?.pinReaders /
                                                                                                        opening_details[
                                                                                                            opening_details.findIndex(
                                                                                                                (el) =>
                                                                                                                    el.pdfId == data?.id
                                                                                                            )
                                                                                                        ]?.limit) *
                                                                                                    100
                                                                                                    : "100"
                                                                                            }
                                                                                            label={
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                ) !== -1
                                                                                                    ? opening_details[
                                                                                                        opening_details.findIndex(
                                                                                                            (el) =>
                                                                                                                el.pdfId == data?.id
                                                                                                        )
                                                                                                    ].pinReaders
                                                                                                    : "Loading"
                                                                                            }
                                                                                        />
                                                                                        <span>
                                                                                            Agreed Limit :&nbsp;
                                                                                            <strong>
                                                                                                {opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                ) !== -1
                                                                                                    ? opening_details[
                                                                                                        opening_details.findIndex(
                                                                                                            (el) => el.pdfId == data?.id
                                                                                                        )
                                                                                                    ]?.limit == 100000
                                                                                                        ? "Unlimited"
                                                                                                        : opening_details[
                                                                                                            opening_details.findIndex(
                                                                                                                (el) =>
                                                                                                                    el.pdfId == data?.id
                                                                                                            )
                                                                                                        ]?.limit
                                                                                                    : "Unlimited"}
                                                                                            </strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <span className="total-left">
                                                                                        {opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        ) !== -1
                                                                                            ? opening_details[
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                )
                                                                                            ]?.limit == 100000
                                                                                                ? null
                                                                                                : opening_details[
                                                                                                    opening_details.findIndex(
                                                                                                        (el) => el.pdfId == data?.id
                                                                                                    )
                                                                                                ]?.limit -
                                                                                                opening_details[
                                                                                                    opening_details.findIndex(
                                                                                                        (el) => el.pdfId == data?.id
                                                                                                    )
                                                                                                ]?.pinReaders
                                                                                            : null}

                                                                                        {opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        ) !== -1 ? (
                                                                                            opening_details[
                                                                                                opening_details.findIndex(
                                                                                                    (el) => el.pdfId == data?.id
                                                                                                )
                                                                                            ]?.limit != 100000 ? (
                                                                                                <small>Left</small>
                                                                                            ) : null
                                                                                        ) : null}
                                                                                    </span>
                                                                                </li>
                                                                                : null
                                                                        }
                                                                    </>
                                                                )
                                                                :
                                                                <li className="d-flex align-center">
                                                                    <h6 className="tab-content-title">
                                                                        Unique reader (total)
                                                                        <LinkWithTooltip tooltip="Number of unique HCPs who have opened the content (based on IP address, device &amp; browser).">
                                                                            <img
                                                                                src={
                                                                                    path_image +
                                                                                    "info_circle_icon.svg"
                                                                                }
                                                                                alt="refresh-btn"
                                                                            />
                                                                        </LinkWithTooltip>
                                                                    </h6>
                                                                    <div className="data-progress send">
                                                                        <ProgressBar
                                                                            variant={
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                ) !== -1
                                                                                    ? opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.unique > 0
                                                                                        ? "warning"
                                                                                        : "default"
                                                                                    : "default"
                                                                            }
                                                                            now={
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                ) !== -1
                                                                                    ? (opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.unique /
                                                                                        opening_details[
                                                                                            opening_details.findIndex(
                                                                                                (el) =>
                                                                                                    el.pdfId == data?.id
                                                                                            )
                                                                                        ]?.limit) *
                                                                                    100
                                                                                    : "100"
                                                                            }
                                                                            label={
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                ) !== -1
                                                                                    ? opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.unique
                                                                                    : "Loading"
                                                                            }
                                                                        />
                                                                        <span>
                                                                            Agreed Limit :&nbsp;
                                                                            <strong>
                                                                                {opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                ) !== -1
                                                                                    ? opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.limit == 100000
                                                                                        ? "Unlimited"
                                                                                        : opening_details[
                                                                                            opening_details.findIndex(
                                                                                                (el) =>
                                                                                                    el.pdfId == data?.id
                                                                                            )
                                                                                        ]?.limit
                                                                                    : "Unlimited"}
                                                                            </strong>
                                                                        </span>
                                                                    </div>
                                                                    <span className="total-left">
                                                                        {opening_details.findIndex(
                                                                            (el) => el.pdfId == data?.id
                                                                        ) !== -1
                                                                            ? opening_details[
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                )
                                                                            ]?.limit == 100000
                                                                                ? null
                                                                                : opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) => el.pdfId == data?.id
                                                                                    )
                                                                                ]?.limit -
                                                                                opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) => el.pdfId == data?.id
                                                                                    )
                                                                                ]?.unique
                                                                            : null}

                                                                        {opening_details.findIndex(
                                                                            (el) => el.pdfId == data?.id
                                                                        ) !== -1 ? (
                                                                            opening_details[
                                                                                opening_details.findIndex(
                                                                                    (el) => el.pdfId == data?.id
                                                                                )
                                                                            ]?.limit != 1000 ? (
                                                                                <small>Left</small>
                                                                            ) : null
                                                                        ) : null}
                                                                    </span>
                                                                </li>
                                                        }

                                                        {data?.linkType != "Online" ? (
                                                            <li>
                                                                <h6 className="tab-content-title">
                                                                    Registered readers{" "}
                                                                    <LinkWithTooltip tooltip="Number of HCPs who have register for or activated the content.">
                                                                        <img
                                                                            src={
                                                                                path_image +
                                                                                "info_circle_icon.svg"
                                                                            }
                                                                            alt="refresh-btn"
                                                                        />
                                                                    </LinkWithTooltip>
                                                                </h6>
                                                                <div className="data-progress">
                                                                    <ProgressBar
                                                                        variant={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.reader > 0
                                                                                    ? "danger"
                                                                                    : "default"
                                                                                : "default"
                                                                        }
                                                                        now={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? (opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.reader /
                                                                                    opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) =>
                                                                                                el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.limit) *
                                                                                100
                                                                                : "100"
                                                                        }
                                                                        label={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ].reader
                                                                                : "Loading"
                                                                        }
                                                                    />

                                                                    {
                                                                        (data?.linkType == 'Sunshine' || data?.linkType == 'Sunshine USA') && (data?.lastRomanNumber != 2 && data?.lastRomanNumber != 3) ?
                                                                            <span>
                                                                                Agreed Limit :&nbsp;
                                                                                <strong>
                                                                                    {opening_details.findIndex(
                                                                                        (el) => el.pdfId == data?.id
                                                                                    ) !== -1
                                                                                        ? opening_details[
                                                                                            opening_details.findIndex(
                                                                                                (el) =>
                                                                                                    el.pdfId == data?.id
                                                                                            )
                                                                                        ]?.limit == 100000
                                                                                            ? "Unlimited"
                                                                                            : opening_details[
                                                                                                opening_details.findIndex(
                                                                                                    (el) =>
                                                                                                        el.pdfId == data?.id
                                                                                                )
                                                                                            ]?.limit
                                                                                        : "Unlimited"}
                                                                                </strong>
                                                                            </span>
                                                                            : null
                                                                    }

                                                                </div>

                                                                {
                                                                    (data?.linkType == 'Sunshine' || data?.linkType == 'Sunshine USA') && (data?.lastRomanNumber != 2 && data?.lastRomanNumber != 3) ?
                                                                        <span className="total-left">
                                                                            {opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) => el.pdfId == data?.id
                                                                                    )
                                                                                ]?.limit == 100000
                                                                                    ? null
                                                                                    : opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.limit -
                                                                                    opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) => el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.reader
                                                                                : null}

                                                                            {opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1 ? (
                                                                                opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) => el.pdfId == data?.id
                                                                                    )
                                                                                ]?.limit != 100000 ? (
                                                                                    <small>Left</small>
                                                                                ) : null
                                                                            ) : null}
                                                                        </span>
                                                                        : null
                                                                }
                                                            </li>
                                                        ) : null}

                                                        {data?.subLinkAdded ? (
                                                            <li>
                                                                <h6 className="tab-content-title">
                                                                    SubLinks
                                                                    <LinkWithTooltip tooltip="Number of sublinks with content.">
                                                                        <img
                                                                            src={
                                                                                path_image +
                                                                                "info_circle_icon.svg"
                                                                            }
                                                                            alt="refresh-btn"
                                                                        />
                                                                    </LinkWithTooltip>
                                                                </h6>
                                                                <div className="data-progress">
                                                                    <ProgressBar
                                                                        variant={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.subLink > 0
                                                                                    ? "sublink"
                                                                                    : "default"
                                                                                : "default"
                                                                        }
                                                                        now={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? (opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.subLink /
                                                                                    opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) =>
                                                                                                el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.limit) *
                                                                                100
                                                                                : "100"
                                                                        }
                                                                        label={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ].subLink
                                                                                : "Loading"
                                                                        }
                                                                    />
                                                                </div>
                                                            </li>
                                                        ) : null}

                                                        {data?.allow_print ? (
                                                            <li>
                                                                <h6 className="tab-content-title">
                                                                    Printed
                                                                    <LinkWithTooltip tooltip="Number of HCPs who have print the content.">
                                                                        <img
                                                                            src={
                                                                                path_image +
                                                                                "info_circle_icon.svg"
                                                                            }
                                                                            alt="refresh-btn"
                                                                        />
                                                                    </LinkWithTooltip>
                                                                </h6>
                                                                <div className="data-progress">
                                                                    <ProgressBar
                                                                        variant={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.print > 0
                                                                                    ? "print"
                                                                                    : "default"
                                                                                : "default"
                                                                        }
                                                                        now={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? (opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.print /
                                                                                    opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) =>
                                                                                                el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.limit) *
                                                                                100
                                                                                : "100"
                                                                        }
                                                                        label={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ].print
                                                                                : "Loading"
                                                                        }
                                                                    />
                                                                </div>
                                                            </li>
                                                        ) : null}

                                                        {data?.allow_download ? (
                                                            <li>
                                                                <h6 className="tab-content-title">
                                                                    Downloaded
                                                                    <LinkWithTooltip tooltip="Number of HCPs who have download the content.">
                                                                        <img
                                                                            src={
                                                                                path_image +
                                                                                "info_circle_icon.svg"
                                                                            }
                                                                            alt="refresh-btn"
                                                                        />
                                                                    </LinkWithTooltip>
                                                                </h6>
                                                                <div className="data-progress">
                                                                    <ProgressBar
                                                                        variant={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.download > 0
                                                                                    ? "download"
                                                                                    : "default"
                                                                                : "default"
                                                                        }
                                                                        now={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? (opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ]?.download /
                                                                                    opening_details[
                                                                                        opening_details.findIndex(
                                                                                            (el) =>
                                                                                                el.pdfId == data?.id
                                                                                        )
                                                                                    ]?.limit) *
                                                                                100
                                                                                : "100"
                                                                        }
                                                                        label={
                                                                            opening_details.findIndex(
                                                                                (el) => el.pdfId == data?.id
                                                                            ) !== -1
                                                                                ? opening_details[
                                                                                    opening_details.findIndex(
                                                                                        (el) =>
                                                                                            el.pdfId == data?.id
                                                                                    )
                                                                                ].download
                                                                                : "Loading"
                                                                        }
                                                                    />
                                                                </div>
                                                            </li>
                                                        ) : null}
                                                    </ul>
                                                </div>
                                            </Tab>
                                            {!isLikeRdAccount ?
                                                <Tab
                                                    eventKey="sales"
                                                    title={
                                                        localStorage.getItem("group_id") == "3"
                                                            ? "About"
                                                            : "Sales"
                                                    }
                                                    className="flex-column justify-content-between"
                                                >
                                                    <div className="tab-panel">
                                                        <ul className="tab-mail-list">
                                                            {localStorage.getItem("group_id") == 2 && (
                                                                <>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Production person
                                                                        </h6>
                                                                        <h6>
                                                                            {data?.productName
                                                                                ? data.productName
                                                                                : "N/A"}
                                                                        </h6>
                                                                    </li>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Publisher
                                                                        </h6>
                                                                        <h6>
                                                                            {data?.publisherName
                                                                                ? data.publisherName
                                                                                : "N/A"}
                                                                        </h6>
                                                                    </li>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Country
                                                                        </h6>
                                                                        <h6>
                                                                            {data?.country
                                                                                ? data.country
                                                                                : "N/A"}
                                                                        </h6>
                                                                    </li>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Cost Center
                                                                        </h6>
                                                                        <h6>
                                                                            {data?.cost_center &&
                                                                                data?.cost_center !== 0
                                                                                ? data.cost_center
                                                                                : "N/A"}
                                                                        </h6>
                                                                    </li>

                                                                </>
                                                            )}
                                                            {localStorage.getItem("group_id") === "3" &&
                                                                !isLikeRdAccount ? (
                                                                <>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Product
                                                                        </h6>
                                                                        <h6>
                                                                            {data?.product
                                                                                ? data.product
                                                                                : "N/A"}
                                                                        </h6>
                                                                    </li>
                                                                </>
                                                            ) : null}

                                                            {isLikeRdAccount &&
                                                                localStorage.getItem("group_id") === "3" ? (
                                                                <>


                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Mandatory
                                                                        </h6>
                                                                        <h6>
                                                                            {data?.reader_mandatory
                                                                                ? "Yes"
                                                                                : "No"}
                                                                        </h6>
                                                                    </li>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Roles
                                                                        </h6>
                                                                        <h6 className="upper">
                                                                            {data?.trail_user_type
                                                                                ? typeof data?.trail_user_type ==
                                                                                    "string" &&
                                                                                    data?.trail_user_type !== "" && data?.trail_user_type !== "[]"
                                                                                    ? JSON.parse(
                                                                                        data?.trail_user_type
                                                                                    ).join(", ")
                                                                                    : "N/A"
                                                                                : "N/A"}
                                                                        </h6>
                                                                    </li>
                                                                </>
                                                            ) : null}

                                                            {!isLikeRdAccount ? (
                                                                <>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Usage limit
                                                                        </h6>
                                                                        <h6>
                                                                            {data?.limit > 0
                                                                                ? data?.limit
                                                                                : "Unlimited"}
                                                                        </h6>
                                                                    </li>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Allowed
                                                                        </h6>
                                                                        <h6>{changeFormatForPrint(data)}</h6>
                                                                    </li>
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            Link type
                                                                        </h6>
                                                                        <h6>{data?.linkType}</h6>
                                                                    </li>
                                                                </>
                                                            ) : null}

                                                            {
                                                                localStorage.getItem('user_id') === 'iSnEsKu5gB/DRlycxB6G4g==' || localStorage.getItem('user_id') === 'iRbx2CVT2fddhkNa9mlcBQ=='|| octaId.includes(localStorage.getItem("user_id"))
                                                                    ?
                                                                    <li>
                                                                        <h6 className="tab-content-title">
                                                                            <img className="library_go" src={path_image + "library_move.svg"} />
                                                                        </h6>
                                                                        <h6>
                                                                            {
                                                                                data?.sync_onesource ? "Yes" : "No"
                                                                            }
                                                                        </h6>
                                                                    </li>
                                                                    : null
                                                            }


                                                            <li>
                                                                <h6 className="tab-content-title">
                                                                    Upload date
                                                                </h6>
                                                                <h6>{data?.uploadedDate}</h6>
                                                            </li>

                                                            {isUSAPharmaAccount && data.articleOwner == 1 ? <li>
                                                                <h6 className="tab-content-title">
                                                                    Publisher
                                                                </h6>
                                                                <h6>{data?.publisherName}</h6>
                                                            </li> : null}

                                                            {localStorage.getItem("group_id") === "2" ? (
                                                                <li>
                                                                    <h6 className="tab-content-title">
                                                                        Expiration date
                                                                    </h6>
                                                                    <h6>
                                                                        {data?.expireDate
                                                                            ? data.expireDate
                                                                            : "N/A"}
                                                                    </h6>
                                                                </li>
                                                            ) : null}
                                                        </ul>
                                                    </div>
                                                </Tab> : ''}

                                        </Tabs>
                                    </div>
                                </div>
                            )
                        })
                        : null
                }
            </div>

            <QRCodeCanvas
                style={{ display: "none" }}
                id="qr-gen"
                value={qrState?.value}
                size={qrSize}
                level={qrState?.level}
                includeMargin={true}
            />

            <CommonModel
                show={show}
                onClose={setShow}
                heading={heading}
                data={modelData}
                footerButton={footerButton}
                handleSubmit={downloadQRCode}
                handleQR={handleQR}
                qrTitle={qrTitle}
            />


            <CommonConfirmModel
                show={confirmationpopup}
                onClose={hideConfirmationModal}
                fun={commonConfirmModelFun}
                popupMessage={popupMessage}
                path_image={path_image}
                resetDataId={resetDataId}
                onCloseCross={hideConfirmationModal}
            />
        </>
    );
}

export default ArticleDetailedView;